export enum UAModules {
  INTERFACE = 'INTERFACE',
  GLOBAL = 'GLOBAL',
  AUTOMATION = 'AUTOMATION',
  COPILOT = 'COPILOT',
}
